import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface TrainingType {
  active: boolean
  color: string
  icon: string
  name: string
}

export const USE_GET_TRAINING_TYPES_QUERY_KEY = 'useGetTrainingTypes'

export const getTrainingTypes = async (signal?: AbortSignal) => {
  const response = await authAPI.get<TrainingType[]>('/training-type', { signal })
  return response.data
}

export const useGetTrainingTypes = () => {
  return useQuery({
    queryFn: ({ signal }) => getTrainingTypes(signal),
    queryKey: [USE_GET_TRAINING_TYPES_QUERY_KEY],
  })
}
